import React from 'react';
import Tab from 'react-bootstrap/Tab';

function ReasonPersonalInfo() {
  return (
    <Tab.Pane eventKey="reason">
      <div className='content'>
        <div className='heading'>
          <h2>Reasons we share personal information</h2>
        </div>
        <p>All financial companies need to share customers’ personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customers’ personal information;
          the reasons Sentry chooses to share; and whether you can limit this sharing.</p>
        <table>
          <thead>
            <tr>
              <th>Reasons we can share your personal information</th>
              <th>Does Sentry share?</th>
              <th>Can you limit this sharing?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><b>For our everyday business purposes </b>— such as to process your transactions,
                maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
              <td>Yes</td>
              <td>No</td>
            </tr>
            <tr>
              <td><b>For our everyday business purposes </b>— such as to process your transactions,
                maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
              <td>Yes</td>
              <td>No</td>
            </tr>
            <tr>
              <td><b>For our everyday business purposes </b>— such as to process your transactions,
                maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
              <td>Yes</td>
              <td>No</td>
            </tr>
            <tr>
              <td><b>For our everyday business purposes </b>— such as to process your transactions,
                maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
              <td>No</td>
              <td>We do not share</td>
            </tr>
            <tr>
              <td><b>For our everyday business purposes </b>— such as to process your transactions,
                maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
              <td>No</td>
              <td>We do not share</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Tab.Pane>
  );
}

export default ReasonPersonalInfo;
